import React, {useState} from 'react'
import {useSearchParams} from "react-router-dom";
import {PageHeader} from "../../../components/common/pageHeader/PageHeader";
import {Pagination} from "../../../components/common/pagination/Pagination";
import {KTIcon} from "../../../../_metronic/helpers";
import {MyTooltip} from "../../../components/common/tooltip/Tooltip";
import {useQuery} from "react-query";
import {getSosRequest} from "../../../services/sosSvc";
import {separateFormatter} from "../../../utils/separateFormatter";
import moment from "moment";
import {SosMapModal} from "./components/SosMapModal";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {EmptySection} from "../../../components/sections/empty/Empty";
import {ISosItem} from "../../../types/sos";
import {PLACEHOLDER_IMAGE_URL} from "../../../mock/constants";
import imgBaseUrl from "../../../utils/imgBaseUrl";

export const SosPage = () => {
  const [searchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)

  const {
    data: sosData,
    isLoading: sosIsLoading
  } = useQuery(["getSosRequest", page], () => getSosRequest({params: {page, page_size: 8}}))
  const [selectedSos, setSelectedSos] = useState<ISosItem | undefined>()

  const pageDetails = {
    title: "SOS murojaatlar",
    desc: `Jami SOS murojaatlar soni: (${separateFormatter(sosData?.total_items || 0, " ", "ta")})`,
  };

  const totalItems = sosData?.total_items || 0;
  const itemsPerPage = sosData?.page_size || 8;

  const [isOpenSosModal, setIsOpenSosModal] = useState(false);


  return (
      <div>
        <PageHeader pageDetails={pageDetails}/>
        {isOpenSosModal && <SosMapModal isOpenSosModal={isOpenSosModal} selectedSos={selectedSos}
                                        setIsOpenSosModal={setIsOpenSosModal}/>}
        {
          sosIsLoading ? <LoaderSection height={"50vh"}/> : sosData?.data.length === 0 ? <EmptySection/> : <>
            <div className={`card mb-10`}>
              <div className='card-body py-3'>
                <div className='table-responsive'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                    <tr className='fw-bold text-muted'>
                      <th className='min-w-150px'>Foydalanuvchi</th>
                      <th className='min-w-140px'>Vaqt</th>
                      <th className='min-w-120px w-100px'>Holat</th>
                      <th className='min-w-50px w-50px'>Manzil</th>
                    </tr>
                    </thead>
                    <tbody>
                    {sosData?.data?.map((sosItem) => (
                        <tr key={sosItem?.id}>
                          <td>
                            <div className='d-flex align-items-center'>
                              <div className='symbol symbol-45px me-5'>
                                <img className={"object-fit-cover"}
                                     src={imgBaseUrl(sosItem?.user?.avatar!) || PLACEHOLDER_IMAGE_URL} alt=''/>
                              </div>
                              <div className='d-flex justify-content-start flex-column'>
                              <span className='text-dark fw-bold text-hover-primary fs-6'>
                                {sosItem?.user?.first_name} {sosItem?.user?.last_name}
                              </span>
                                <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                {sosItem?.user?.role?.toUpperCase()}
                              </span>
                              </div>
                            </div>
                          </td>

                          <td>
                            <span
                                className='text-dark fw-bold d-block fs-7'>{moment(sosItem?.created_at).format("DD.MM.YYYY HH:mm:ssss")}</span>
                          </td>
                          <td>
                            <div className={"d-flex gap-1 w-200px"}>
                              {sosItem?.status === "SAFE" ?
                                  <span className="badge badge-light-success fs-8 fw-bold">Xavfsiz zonadaman</span>
                                  :
                                  <span className="badge badge-light-danger fs-8 fw-bold">Xavfli hududda</span>
                              }
                            </div>
                          </td>
                          <td>
                            <div className='d-flex w-50px flex-shrink-0'>
                              <MyTooltip title={"Xaritada ko'rish"} position={"top"}>
                                <button
                                    type={"button"}
                                    onClick={() => {
                                      setIsOpenSosModal(true)
                                      setSelectedSos(sosItem)
                                    }}
                                    className={`btn btn-icon ${sosItem?.area === "safe" ? "btn-light-success" : "btn-light-danger"} btn-sm`}
                                >
                                  <KTIcon iconName='geolocation' className='fs-3'/>
                                </button>
                              </MyTooltip>
                            </div>
                          </td>
                        </tr>
                    ))
                    }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Pagination totalItems={totalItems} itemsPerPage={itemsPerPage}/>
          </>
        }
      </div>
  )
}
